export default __webpack_public_path__ + "static/2301-ee3f444f2c0860541202f90bb025e410.gif";